module.exports = __webpack_public_path__ + "images/store_case_study/gameoukoku-pic1_bd736346eb7ff87f272d700c5f2418f0.png";